import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanConfirmationProps as Props } from './types';
import { Divider, Typography } from '@mui/material';

export const PlanConfirmation = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('PlanConfirmation', className)}
      sx={SX.root}
    >
      <Typography variant="body3" color="grey.700" fontWeight={500}>
        Plan Confirmation
      </Typography>

      <Divider sx={SX.divider} />
      <Typography variant="body4" fontWeight={400}>
        Your downgrade to the Free Plan has been successfully canceled.
      </Typography>
    </Styled.Wrapper>
  );
});

PlanConfirmation.displayName = 'PlanConfirmation';
